import React from "react";
import { PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { ChartDataItem } from "../../types/dashboard";

interface ChartContainerProps {
  hasValidData: boolean;
  chartData: ChartDataItem[];
  renderCustomizedLabel: (props: any) => React.ReactNode;
  CustomTooltip: React.ComponentType<any>;
}

const ChartContainer: React.FC<ChartContainerProps> = ({ 
  hasValidData, 
  chartData, 
  renderCustomizedLabel, 
  CustomTooltip 
}) => {
  // Check if all values are zero
  const allZero = chartData.every(item => item.value === 0);
  
  // If all zero, show a placeholder
  if (allZero) {
    return (
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="text-center">
          <div className="w-24 h-24 mx-auto mb-2 rounded-full border-2 border-gray-200 border-dashed flex items-center justify-center">
            <span className="text-3xl text-gray-300">0</span>
          </div>
          <p className="text-sm text-gray-400">No data available</p>
        </div>
      </div>
    );
  }

  // Enhanced cell rendering with better visual effects
  const renderCells = () => {
    return chartData.map((entry, index) => (
      <Cell
        key={`cell-${index}`}
        fill={entry.color}
        stroke="#ffffff"
        strokeWidth={3}
        strokeOpacity={0.9}
        opacity={entry.value === 0 ? 0.3 : 1}
        className="transition-all duration-500 ease-out hover:opacity-90 hover:scale-105"
        style={{
          filter: entry.value > 0 ? `drop-shadow(0 4px 8px ${entry.color}40)` : "none",
        }}
      />
    ));
  };

  return (
    <div className="relative w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={100}
            innerRadius={60}
            paddingAngle={2}
            dataKey="value"
            animationDuration={200}
            startAngle={90}
            endAngle={450}
            className="transition-all duration-700 ease-out"
          >
            {renderCells()}
          </Pie>
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(255, 255, 255, 0.1)" }} />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartContainer;